import { useMutation } from '@tanstack/react-query';
import { userApiClient } from 'src/api/FiretrolApiClientInstances';

/**
 * Impersonation is validated server-side before the client flips its cache
 * scope, so this mutation deliberately declares no invalidations — the caller
 * hard-clears the whole query cache instead.
 */
export function useAssumeUser() {
  return useMutation({
    mutationFn: (userId: number) => userApiClient.assumeUser(userId),
    meta: { suppressErrorToast: true, errorContext: 'assume user' },
  });
}
